import React from 'react';

import CountryInfo from '../CountryInfo';

const CRISIS_FUND_SECTION = {
    title: 'Anti-Coronavirus Assistance',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Assistance Details</p>
            <ul>
                <li>
                    Banks to offer firms and households in good financial shape
                    increased loans and better terms over the next six months.
                    Up to 3.2 trillion reais ($640 billion) of loans can be
                    applied.
                </li>
                <li>
                    56 billion reais relaxation in banks’ capital requirements
                    could free up a potential 637 billion reais for fresh
                    lending across the economy.
                </li>
                <li>
                    Business subsidies to stimulate industries most susceptible
                    to impact.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Brazil takes emergency anti-coronavirus steps to boost liquidity, bank lending',
            url: 'https://business.financialpost.com/pmn/business-pmn/brazil-takes-emergency-anti-coronavirus-steps-to-boost-liquidity-bank-lending',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Brazil',
    lastUpdated: 'March 21, 2020',
    introSection: (
        <p>
            Brazil has announced several emergency anti-coronavirus assistance.
        </p>
    ),
    sections: [CRISIS_FUND_SECTION],
};

const BrazilInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default BrazilInfo;
